import { createContext, useContext } from "react";

export const LOCKED_STATUSES = ["Cancelled", "Approved", "Declined", "Boarded", "Live", "Merged"] as const;

export const PRICING_LOCKED_STATUSES = ["ESignSent", "ESigned", "ActionNeeded", "Underwriting", "Approved", "Boarded", "Live"] as const;

export const isPricingLocked = (status: string): boolean =>
  (PRICING_LOCKED_STATUSES as readonly string[]).includes(status);

export const isLockedStatus = (status: string): boolean =>
  (LOCKED_STATUSES as readonly string[]).includes(status);

export const ReadOnlyContext = createContext(false);

export const useReadOnly = (): boolean => useContext(ReadOnlyContext);
